import styled, { keyframes } from "styled-components";
import zindex from "#app/interface/zindex";
import {
    backgroundPrimary,
    backgroundSecondary,
    textPrimary,
    textLabel,
    overlayBackdrop,
} from "#app/styles/designTokens";

const rotate = keyframes`
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
`;

export const Overlay = styled.div.attrs({ className: "overlay-container" })`
    overflow: hidden;
    position: fixed;
    top: 0 !important;
    left: 0 !important;
    width: 100%;
    height: 100%;
    text-align: center;
    vertical-align: middle;
    z-index: ${zindex.modal};
    transition: opacity 0.3s ease-in-out;
    background-color: ${overlayBackdrop};

    & > div {
        transition: transform 0.2s ease-in-out;
        position: absolute;
        height: fit-content;
        min-height: 1400px;
        top: 0 !important;
        left: 0 !important;
    }
`;

export const Wrapper = styled.div`
    position: relative;
    top: 0 !important;
    left: 0 !important;
    width: 100%;
    height: 100vh;
    line-height: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: ${zindex.modal};
`;

interface ModalProps {
    width?: string | number;
    allowRelativeWidthOnMedia?: boolean;
}

export const Modal = styled.div<ModalProps>`
    padding-top: 100px;
    padding-bottom: 100px;
    display: inline-block;
    position: relative;
    transition: opacity 1s;
    max-width: 786px;

    ${(props) =>
        props.width &&
        `
        min-width: ${props.width};
        max-width: ${props.width};
    `}

    ${(props) =>
        props.allowRelativeWidthOnMedia &&
        `
        @media screen and (max-width: 2100px) {
            min-width: 80vw !important;
            max-width: 80vw !important;
        }
    `}
`;

export const ModalHeader = styled.div`
    align-items: center;
    background-color: ${backgroundPrimary};
    display: flex;
    flex-shrink: 0;
    justify-content: flex-start;
    padding: 20px 20px 0 20px;
    position: relative;
    color: ${textLabel};
    flex-grow: 1;
    font-size: 24px;
    line-height: 1;
    border-top-left-radius: 24px;
    border-top-right-radius: 24px;
    font-weight: 600;
    height: 60px;

    & > div {
        width: 100%;
        text-align: left;
        color: ${textPrimary};
    }

    & > button {
        background-color: ${backgroundPrimary};
        border: none;
        cursor: pointer;
    }
`;

export const ModalClose = styled.span`
    background-color: ${backgroundSecondary};
    padding: 4px;
    position: absolute;
    top: 10px;
    right: 10px;
    border-radius: 72px;
    cursor: pointer;
    width: 24px;
    height: 24px;
    line-height: 20px;
`;

export const ModalContentScroll = styled.div`
    max-height: 70vh;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    box-sizing: border-box;
`;

export const ModalFooter = styled.div`
    align-items: center;
    background-color: ${backgroundPrimary};
    display: flex;
    flex-shrink: 0;
    justify-content: flex-start;
    padding: 5px 20px 20px 20px;
    position: relative;
    color: ${textLabel};
    flex-grow: 1;
    font-size: 1.5rem;
    flex-wrap: wrap;
    line-height: 1;
    border-bottom-left-radius: 24px;
    border-bottom-right-radius: 24px;

    & > * {
        max-width: 100%;
    }
`;

export const ModalLoader = styled.span`
    position: absolute;
    top: 30px;
    left: 30px;
    animation: ${rotate} 2s linear infinite;
`;
